/**
 * Engine-wide constants.
 */

export const ENGINE_VERSION = '0.1.0';

// Timing
export const FIXED_DT = 1 / 60;
export const MAX_FIXED_STEPS = 5;

// ECS limits
export const MAX_ENTITY_COUNT = 65536;
export const MAX_COMPONENT_TYPES = 256;
export const MAX_SYSTEMS = 128;

// Physics
export const WALK_SPEED = 8;
export const SPRINT_SPEED = 12;
export const GRAVITY = -9.81;
export const COYOTE_TIME_MS = 100;
export const JUMP_BUFFER_MS = 100;

// Networking
export const RECONNECT_BASE_MS = 1000;
export const RECONNECT_MAX_MS = 30000;
export const INPUT_BUFFER_CAPACITY = 128;
export const POSITION_ERROR_THRESHOLD = 0.1;

// Rendering
export const MAX_PIXEL_RATIO = 2;
export const DEFAULT_EXPOSURE = 1.0;

// AOI / Interest Management
export const AOI_DEFAULT_CELL_SIZE = 64;
export const AOI_DEFAULT_RADIUS_CELLS = 2;
export const AOI_DEFAULT_HYSTERESIS_CELLS = 1;
export const AOI_DEFAULT_UPDATE_INTERVAL_TICKS = 6;
export const AOI_DEFAULT_MAX_QUERIES = 8;

// Rollback netcode
export const ROLLBACK_JITTER_MARGIN = 8;
export const DEFAULT_MAX_ROLLBACK_FRAMES = 12;
export const DEFAULT_INPUT_DELAY_FRAMES = 2;
export const DEFAULT_HASH_INTERVAL_TICKS = 30;
